import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import React from "react";
import NumberFormat from "react-number-format";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { actions } from "../../../redux/actions/alert";
import { actions as cartActions } from "../../../redux/actions/shoppingCart";
import styles from "../../../styles/global-styles";
import { isBalanceTransferInCart } from "../../../_utils/utils";
import { ConfirmButtons } from "../../stateless/ConfirmButtons";
import Transition from "../../stateless/Transition";

const usetSyles = makeStyles((theme) => ({
  typography: {
    fontWeight: 400,
    marginBottom: 8,
    color: "#1C2668",
    opacity: 0.5,
  },
  nameSite: {
    color: "#1C2668",
    fontWeight: 600,
    position: "absolute",
    top: "180px",
    marginLeft: 40,
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      width: "8vw !Important",
      maxWidth: 150,
      border: "0.2px solid #f2f2f2",
    },
  },
  chip: styles.chip,
}));

const MovileInfoModal = ({
  addAlert,
  detailAlert,
  searchBySite,
  open,
  onClose,
  detailProduct,
  addItemToCart,
  productId,
  shoppingCart: { cart },
}) => {
  const classes = usetSyles();
  const history = useHistory();
  const handleClose = () => onClose();

  const goToUrl = (inDistribution) => {
    if (inDistribution) {
      history.push(`/dashboard/inventario/distribucion`);
    } else {
      const {
        movile: { brand, model },
      } = detailProduct;
      history.push(`/dashboard/inventario/detalle-producto`, {
        brand,
        model,
        productTypeId: 1,
      });
    }
  };

  const handleAcceptOption = () => {
    if (searchBySite) {
      if (isBalanceTransferInCart(cart)) {
        addAlert({ showAlert: true });
        detailAlert({
          severity: "info",
          message:
            "Ya tienes en el carrito un trapaso de saldo. Favor de eliminar para continuar",
        });
        onClose();
        return;
      } else if (Object.keys(cart).some((item) => item === detailProduct.id)) {
        addAlert({ showAlert: true });
        detailAlert({
          severity: "info",
          message: "El producto ya se encuentra en tu carrito",
        });
      } else addItemToCart({ item: detailProduct, quantity: 1 });

      onClose();
    } else goToUrl();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth={true}
      maxWidth="sm"
      keepMounted
      TransitionComponent={Transition}
      aria-labelledby="simple-dialog-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="simple-dialog-title" style={{ textAlign: "center" }}>
        Equipo movil
      </DialogTitle>
      <DialogContent>
        {/**
        <Typography
          color="primary"
          align="justify"
          variant="h6"
          style={{ fontWeight: 800, marginBottom: 30 }}
        >
          {detailProduct.inDistribution ? "En distribución" : ""}
        </Typography>
         */}
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="center"
          spacing={2}
        >
          <Grid item xs={3} md={4} lg={3}>
            <Typography
              color="primary"
              align="justify"
              className={classes.typography}
              variant="subtitle1"
            >
              Marca
            </Typography>
            <Typography> {detailProduct.movile?.brand}</Typography>
          </Grid>
          <Grid item xs={3} md={4} lg={3}>
            <Typography
              color="primary"
              align="justify"
              className={classes.typography}
              variant="subtitle1"
            >
              Modelo
            </Typography>
            <Typography>{detailProduct.movile?.model}</Typography>
          </Grid>
          <Grid item xs={3} md={4} lg={3}>
            <Typography
              color="primary"
              align="justify"
              className={classes.typography}
              variant="subtitle1"
            >
              Color
            </Typography>
            <Typography>{detailProduct.movile?.color}</Typography>
          </Grid>

          <Grid item xs={3} md={4} lg={3}>
            <Typography
              color="primary"
              align="justify"
              className={classes.typography}
              variant="subtitle1"
            >
              Capacidad
            </Typography>
            <Typography>{detailProduct.movile?.capacity}</Typography>
          </Grid>

          {searchBySite && (
            <>
              <Grid item xs={3} md={4} lg={3}>
                <Typography
                  color="primary"
                  align="justify"
                  className={classes.typography}
                  variant="subtitle1"
                >
                  Precio
                </Typography>
                <Typography>
                  {" "}
                  <NumberFormat
                    value={detailProduct.movile?.price || 0}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"$"}
                  />
                </Typography>
              </Grid>

              <Grid item xs={3} md={4} lg={3}>
                <Typography
                  color="primary"
                  align="justify"
                  className={classes.typography}
                  variant="subtitle1"
                >
                  Descuento
                </Typography>
                <Typography>
                  {" "}
                  <NumberFormat
                    value={detailProduct.movile?.discount || 0}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"$"}
                  />
                </Typography>
              </Grid>

              <Grid item xs={3} md={4} lg={3}>
                <Typography
                  color="primary"
                  align="justify"
                  className={classes.typography}
                  variant="subtitle1"
                >
                  Lote
                </Typography>
                <Typography>{detailProduct.movile?.lote}</Typography>
              </Grid>

              <Grid item xs={3} md={4} lg={5}>
                <Typography
                  color="primary"
                  align="justify"
                  className={classes.typography}
                  variant="subtitle1"
                >
                  Código de barras
                </Typography>
                <Typography>{detailProduct.movile?.barCode}</Typography>
              </Grid>
            </>
          )}

          <Grid item xs={3} md={4} lg={5}>
            <Typography
              color="primary"
              align="justify"
              className={classes.typography}
              variant="subtitle1"
            >
              Proveedor
            </Typography>
            <Typography>
              {searchBySite
                ? detailProduct.movile?.provider?.alias
                : detailProduct.movile?.provider?.name || ""}
            </Typography>
          </Grid>
        </Grid>
        <ConfirmButtons
          acceptTitle={searchBySite ? "Agregar a carrito" : "Ir a detalle"}
          cancel={onClose}
          accept={() => handleAcceptOption()}
        />
      </DialogContent>
    </Dialog>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
  addItemToCart: cartActions.addItemToCart,
};

const mapStateToProps = (state) => ({
  shoppingCart: state.shoppingCart,
});

export default connect(mapStateToProps, dispatch)(MovileInfoModal);
